import React from 'react';
import InfiniteScroll from 'react-infinite-scroller';
import ContainerPlayer from 'shared/container-player';
import ContainerType from 'shared/container-type';
import { hideLoadingFeed, showLoadingFeed } from 'utils/exploreHelpers';
import * as spt from 'shared/propTypes';
import { Spinner } from 'components/uniform';

import { FeedItem } from 'hudl-feed';

class ExploreFeed extends React.Component {
  static propTypes = {
    discoveryTimelines: React.PropTypes.arrayOf(spt.discoveryTimeline).isRequired,
    isFetching: React.PropTypes.object.isRequired,
    onExploreFeedScrollNearBottom: React.PropTypes.func.isRequired,
    feedItems: React.PropTypes.arrayOf(spt.feedItem).isRequired,
    currentTab: spt.discoveryTimeline,
    adTag: spt.adTag,
  }

  static contextTypes = {
    store: React.PropTypes.object,
  }

  getFeedItems() {
    return this.props.feedItems && this.props.feedItems[this.props.currentTab.timelineKey];
  }

  getRenderedFeedItems() {
    if (this.props.feedItems && this.props.feedItems[this.props.currentTab.timelineKey]) {
      const feedItems = this.getFeedItems();
      if (feedItems.length > 0) {
        const feedItemComponents = [];
        const hideFollowButton = true;
        const canDismiss = false;

        const logData = {
          container: ContainerType.Explore,
          containerSection: this.props.currentTab.containerSection,
          player: ContainerPlayer.TimelineCard,
        };
        for (const item of feedItems) {
          feedItemComponents.push(
            <FeedItem key={item.feedContentId}
              adTag={this.props.adTag}
              store={this.context.store}
              feedContentId={item.feedContentId}
              timelineUserId={{type: 3, relatedId: '-1'}}
              hideFollowButton={hideFollowButton}
              canDismiss={canDismiss}
              logData={logData}/>
          );
        }

        return feedItemComponents;
      }
    }
  }

  renderLoadingSpinner() {
    if (!this.props.isFetching[this.props.currentTab.timelineKey]) {
      return null;
    }

    return (
      <div className="explore-feed__spinner-container">
        <Spinner size="medium" />
      </div>
    );
  }

  render() {
    const isFetching = this.props.isFetching[this.props.currentTab.timelineKey];
    const feedItems = this.getFeedItems();
    const hasAnyFeedItems = feedItems && feedItems.length;
    let shouldShowLoadingFeed = false;
    // If it's currently fetching, and there are no feed items, then render the loading state.
    // If it's currently fetching, and there are some feed items, do not render the loading state.
    // If it's not fetching, or there are some feed items, hide the loading state.
    if (isFetching) {
      if (!hasAnyFeedItems) {
        shouldShowLoadingFeed = true;
      }
    }
    if (shouldShowLoadingFeed) {
      showLoadingFeed();
    } else {
      hideLoadingFeed();
    }
    const renderedFeedItems = this.getRenderedFeedItems();
    if (!hasAnyFeedItems) {
      return null;
    }
    return (
      <div className="content js-explore-tabs-content" data-current-tab={this.props.currentTab.containerSection}>
        <InfiniteScroll
          pageStart={0}
          initialLoad={false}
          loader={this.renderLoadingSpinner()}
          loadMore={this.props.onExploreFeedScrollNearBottom}
          threshold={400}
          hasMore
          useWindow
        >
          {/* TODO - Allow specifying the scroll element:
            https://github.com/CassetteRocks/react-infinite-scroller/pull/38 */}
          {renderedFeedItems}
        </InfiniteScroll>
      </div>
    );
  }
}

export default ExploreFeed;
